import { get, deleteRequest, post, patch } from 'utils/api';

export const getUserGroupPricing = (data) => {
  return get(`/userGroupTariff`, data);
};

export const addUserGroupPricing = (data) => {
  return post(`/userGroupTariff`, data);
};

export const updateUserGroupPricing = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/userGroupTariff/${id}`, data);
};

export const deleteUserGroupPricing = (id) => {
  return deleteRequest(`/userGroupTariff/${id}`);
};

export const getUserGroupPricingById = (id) => {
  return get(`/userGroupTariff/${id}`);
};

export const userGroupPricing = {
  getUserGroupPricing,
  addUserGroupPricing,
  updateUserGroupPricing,
  deleteUserGroupPricing,
  getUserGroupPricingById,
};
